import { config } from '../config/env';

export function getEvalSetDisplayName(id: string): string {
  return config.evalSetDisplayNames[id] ?? id;
}

export function resolveEvalSetSearch(search: string): string {
  const match = Object.entries(config.evalSetDisplayNames).find(
    ([, name]) => name.toLowerCase() === search.trim().toLowerCase()
  );
  return match ? match[0] : search;
}
